import React from 'react';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { mergeSx } from '../../../../../utils/sx/merge';
import { SelectButton } from '../../../../selectButton';
import { CALENDAR_WIDTH } from './const';
import { DateTimePickerProps } from './model';

export interface DateTimePickerFieldProps {
  active: boolean;
  disabled?: boolean;
  name?: string;
  value: string | Date | undefined;
  innerValue: Date | null;
  placeholder?: string | React.ReactNode;
  labelDateFormat: string | ((date: Date) => string);
  size?: DateTimePickerProps['size'];
  sx?: DateTimePickerProps['sx'];
  isMobile: boolean;
  fieldRef: React.Ref<HTMLDivElement>;
  onToggle: () => void;
}

/**
 * Custom field component for DatePicker
 */
export const DateTimePickerField: React.FC<DateTimePickerFieldProps> = ({
  active,
  disabled,
  name,
  value,
  innerValue,
  placeholder,
  labelDateFormat,
  size,
  sx,
  isMobile,
  fieldRef,
  onToggle,
}) => {
  const displayValue = React.useMemo(() => {
    if (!innerValue) {
      return placeholder;
    }

    return typeof labelDateFormat === 'function' ? labelDateFormat(innerValue) : format(innerValue, labelDateFormat, { locale: ru });
  }, [innerValue, placeholder, labelDateFormat]);

  const buttonSx = React.useMemo(
    () => mergeSx({ width: isMobile ? 1 : CALENDAR_WIDTH, maxWidth: isMobile ? 1 : CALENDAR_WIDTH }, sx),
    [isMobile, sx],
  );

  return (
    <SelectButton
      active={active}
      disabled={disabled}
      inputName={name}
      inputValue={String(value)}
      onClick={onToggle}
      ref={fieldRef}
      size={size}
      sx={buttonSx}
    >
      {displayValue}
    </SelectButton>
  );
};
